export const userEndpoints = {
  getUser: (id: string) => `/private/v1/users/${id}`,
  createNewExternalUser: '/private/v1/users/external',
  listExternalUsers: '/private/v1/users/external',
  deleteExternalUser: (id: string) => `/private/v1/users/external/${id}`,
  getEncapsKey: (id: string) => `/private/v1/users/${id}/encapskey`,
  getDecapsKey: (id: string) => `/private/v1/users/${id}/decapskey`,
} as const;

export type UserEndpointKey = keyof typeof userEndpoints;
